import { render, staticRenderFns } from "./ReadLegalNotice.vue?vue&type=template&id=0ce35616"
import script from "./ReadLegalNotice.vue?vue&type=script&lang=js"
export * from "./ReadLegalNotice.vue?vue&type=script&lang=js"
import style0 from "./ReadLegalNotice.vue?vue&type=style&index=0&id=0ce35616&prod&lang=less&Scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports